import { useEffect, useState } from 'react';
import { timeAgo } from 'common/utils';

// Re-renders on an interval so the displayed string keeps advancing
// (e.g. "Just now" -> "1m" -> "2m") while the page stays open.
export const useTimeAgo = (date: string | Date | null | undefined, intervalMs = 30000): string => {
  const [, forceTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => forceTick(tick => tick + 1), intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);

  if (!date) return '';
  return timeAgo(new Date(date));
};
